import { Fancybox } from "@fancyapps/ui";

const YOUTUBE_SERVICE_ID = "youtube";
const VIDEO_ID_PATTERN = /^[A-Za-z0-9_-]{11}$/;

const fancyboxOptions = {
  theme: "light",
  hideScrollbar: false,
  mainClass: "fancybox-brand",
  Video: {
    autoplay: true,
  },
};

let allowWithoutBorlabs = false;

function canPlay() {
  const borlabs = window.BorlabsCookie;

  if (!borlabs) {
    return allowWithoutBorlabs;
  }

  if (
    typeof borlabs.Services?.findByServiceId !== "function" ||
    typeof borlabs.Consents?.hasConsent !== "function"
  ) {
    return false;
  }

  try {
    if (borlabs.Services.findByServiceId(YOUTUBE_SERVICE_ID) === null) {
      return false;
    }

    return borlabs.Consents.hasConsent(YOUTUBE_SERVICE_ID) === true;
  } catch {
    return false;
  }
}

function videoIdFrom(button) {
  const id = button.getAttribute("data-video-id") || "";

  return VIDEO_ID_PATTERN.test(id) ? id : "";
}

function revealThumbnails(root = document) {
  if (!canPlay()) {
    return;
  }

  root
    .querySelectorAll(".video-gallery__trigger[data-video-thumb]")
    .forEach((button) => {
      if (
        !(button instanceof HTMLElement) ||
        button.querySelector(".video-gallery__image")
      ) {
        return;
      }

      const id = videoIdFrom(button);

      if (id === "") {
        return;
      }

      const img = document.createElement("img");
      img.className = "video-gallery__image";
      img.alt = "";
      img.addEventListener(
        "error",
        () => {
          img.remove();
        },
        { once: true },
      );
      img.src = `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;
      button.prepend(img);
      button.removeAttribute("data-video-thumb");
    });
}

function openGallery(gallery, index) {
  const buttons = [...gallery.querySelectorAll(".video-gallery__trigger")];
  const items = buttons
    .map((button) => {
      const id = videoIdFrom(button);

      if (id === "") {
        return null;
      }

      const item = {
        src: `https://www.youtube.com/watch?v=${encodeURIComponent(id)}`,
      };
      const caption = button.getAttribute("data-caption");

      if (caption) {
        item.caption = caption;
      }

      return item;
    })
    .filter(Boolean);

  if (items.length === 0) {
    return;
  }

  Fancybox.show(items, {
    ...fancyboxOptions,
    startIndex: Math.min(Math.max(index, 0), items.length - 1),
  });
}

function openBlocker(button) {
  const gallery = button.closest(".video-gallery");
  const blockerId = button.getAttribute("data-blocker-id") || "";
  const template = blockerId
    ? gallery?.querySelector(
        `template[data-blocker-id="${CSS.escape(blockerId)}"]`,
      )
    : null;

  if (!gallery || !(template instanceof HTMLTemplateElement)) {
    return;
  }

  gallery
    .querySelectorAll(".video-gallery__blocker")
    .forEach((node) => node.remove());

  const blocker = document.createElement("div");
  blocker.id = blockerId;
  blocker.className = "video-gallery__blocker";
  blocker.append(template.content.cloneNode(true));
  gallery.append(blocker);

  Fancybox.show([{ src: `#${blockerId}`, type: "inline" }], {
    ...fancyboxOptions,
    mainClass: "fancybox-brand fancybox-video-blocker",
    on: {
      close: () => {
        window.setTimeout(() => blocker.remove(), 0);
      },
    },
  });
}

function onTriggerClick(button) {
  const gallery = button.closest(".video-gallery");

  if (!gallery) {
    return;
  }

  const buttons = [...gallery.querySelectorAll(".video-gallery__trigger")];
  const index = buttons.indexOf(button);

  if (!canPlay()) {
    openBlocker(button);
    return;
  }

  openGallery(gallery, index);
}

function onConsentSaved() {
  if (canPlay()) {
    revealThumbnails();
  }
}

document.addEventListener("click", (event) => {
  const button = event.target.closest(".video-gallery__trigger");

  if (!button) {
    return;
  }

  onTriggerClick(button);
});

window.addEventListener("borlabs-cookie-after-init", () => {
  if (canPlay()) {
    revealThumbnails();
  }
});

window.addEventListener("borlabs-cookie-consent-saved", onConsentSaved);

if (canPlay()) {
  revealThumbnails();
}

window.addEventListener("load", () => {
  if (typeof window.BorlabsCookie === "undefined") {
    allowWithoutBorlabs = true;
    revealThumbnails();
  }
});
